import styled from '../../../../theme'

const Separator = styled.div`
  margin: 0px 25px;
  font-weight: 600;
`

export default Separator
